class RolesStore {
  constructor() {
    this.userRoles = null;
  }

  setRoles(roles) {
    this.userRoles = roles;
  }

  getRoles() {
    return this.userRoles;
  }
}

export const rolesStore = new RolesStore();
